import { render } from "./RolesAndPermissionsModal.vue?vue&type=template&id=56194569&scoped=true"
import script from "./RolesAndPermissionsModal.vue?vue&type=script&lang=js"
export * from "./RolesAndPermissionsModal.vue?vue&type=script&lang=js"

import "./RolesAndPermissionsModal.vue?vue&type=style&index=0&id=56194569&scoped=true&lang=css"
import "./RolesAndPermissionsModal.vue?vue&type=style&index=1&id=56194569&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56194569"]])

export default __exports__